import React from 'react';
import { SubmissionError } from 'redux-form';
import NewContactForm from './NewContactForm';
import axios from './../../constants/axios';
import alert from 'alertify.js';
import selectOptionFormatter from './../../selectors/selectOptionFormatter';

class NewContact extends React.Component {

   constructor(props, context) {
      super(props, context);
      this.state = {
         contactTypes: []
      };
   }

   componentDidMount() {
      axios.get('contactTypes')
         .then((res) => {
            this.setState({
               contactTypes: selectOptionFormatter(res.data)
            });
         });
   }

   createNewContact = (contact) => {
      return axios
         .post('contacts', contact)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Created');
               this.context.router.push('/contact');
            } else {
               alert.error('Something went wrong.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            }
         });
   };


   render() {
      return (
         <NewContactForm contactTypes={this.state.contactTypes} createNewContact={this.createNewContact} />
      );
   }
}

NewContact.contextTypes = {
   router: React.PropTypes.object.isRequired
};


export default NewContact;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/NewContact.js
 **/